<template>
    <div class="online-dossier" :class="{ 'is-loading': isLoading }">
        <div class="online-dossier__header">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-6">
                        <router-link :to="{ name: 'onlineProjectDossier', params: { id: this.$route.params.id } }" exact="">
                            <img :src="`${publicPath}img/logo-wit.svg`" alt="" width="225" height="38" class="logo">
                            <img :src="`${publicPath}img/logo.svg`" alt="" width="225" height="38" class="logo-mobile">
                        </router-link>
                    </div>

                    <div class="col-6 text-md-right online-dossier__additional">
                        <p>{{ onlineProjectDossier.file_id }} &mdash; {{ onlineProjectDossier.name }}</p>
                    </div>

                    <div class="col-6 online-dossier__toggle">
                        <button @click.prevent="toggleOffcanvas">
                            <img :src="`${publicPath}img/navigation.svg`" alt="">
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-3 mt-md-5">
            <div class="row">
                <div class="col-12 col-md-3 online-dossier__sidebar">
                    <div class="online-dossier__sidebar-inner">
                        <h3>Algemeen</h3>
                        <ul>
                            <li>
                                <router-link :to="{ name: 'onlineProjectDossier', params: { id: this.$route.params.id } }" exact="">Projectgegevens</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'onlineProjectDossierCustomer', params: { id: this.$route.params.id } }">Opdrachtgever</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'onlineProjectDossierCompany', params: { id: this.$route.params.id } }">Bedrijfsgegevens</router-link>
                            </li>
                        </ul>

                        <h3>Opgenomen objecten</h3>
                        <ul>
                            <li v-for="property in onlineProjectDossier.properties" :key="property.id">
                                <router-link :to="{ name: 'onlineProjectDossierObject', params: { id: onlineProjectDossier.id, token: property.token } }">
                                    {{ property.address }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-12 col-md-9">
                    <transition name="fade" mode="out-in">
                        <router-view @onRouteChange="hideOffcanvas"/>
                    </transition>
                </div>
            </div>
        </div>

        <div class="offcanvas" :class="{ 'active': offcanvasActive }">
            <div class="offcanvas__container">
                <div class="offcanvas__navigation">
                    <div class="container">
                        <div class="offcanvas__left">
                            <a class="header__brand" href="#">
                                <img :src="`${publicPath}img/logo.svg`" alt="" width="225" height="38">
                            </a>
                        </div>

                        <button class="offcanvas__toggle" @click.prevent="toggleOffcanvas">
                            &times;
                        </button>
                    </div>
                </div>

                <div class="offcanvas__menu">
                    <div class="container">
                        <h3>Algemeen</h3>
                        <ul>
                            <li>
                                <router-link :to="{ name: 'onlineProjectDossier', params: { id: this.$route.params.id } }" exact="">Projectgegevens</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'onlineProjectDossierCustomer', params: { id: this.$route.params.id } }">Opdrachtgever</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'onlineProjectDossierCompany', params: { id: this.$route.params.id } }">Bedrijfsgegevens</router-link>
                            </li>
                        </ul>

                        <h3>Opgenomen objecten</h3>
                        <ul>
                            <li v-for="property in onlineProjectDossier.properties" :key="property.id">
                                <router-link :to="{ name: 'onlineProjectDossierObject', params: { id: onlineProjectDossier.id, token: property.token } }">
                                    {{ property.address }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { FETCH_ONLINE_PROJECT_DOSSIER } from '../../store/modules/onlineProjectDossier'

	export default {
		data () {
			return {
				isLoading: true,
				offcanvasActive: false,
				publicPath: process.env.BASE_URL,
			}
		},

		computed: {
			...mapGetters([
				'onlineProjectDossier',
			]),
		},

		mounted () {
			this.fetchData()
		},

		methods: {
			fetchData () {
				this.$store.dispatch(FETCH_ONLINE_PROJECT_DOSSIER, this.$route.params.id).then(() => {
					this.isLoading = false
				})
			},

			toggleOffcanvas () {
				this.offcanvasActive = !this.offcanvasActive
			},

			hideOffcanvas () {
				this.offcanvasActive = false
			},
		},

		watch: {
			'$route': function () {
				this.hideOffcanvas()
			},
		},
	}
</script>